import type { Version } from "./briefTypes";

interface BriefVersionHistoryProps {
  versions: Version[];
  onViewVersion: (version: Version) => void;
}

export function BriefVersionHistory({ versions, onViewVersion }: BriefVersionHistoryProps) {
  if (!versions.length) return null;

  return (
    <div className="rounded-lg bg-card p-4 shadow-sm ring-1 ring-ring">
      <h3 className="text-sm font-medium text-text-secondary">Version History</h3>
      <div className="mt-3 space-y-2">
        {versions.map((version) => (
          <button
            key={version.id}
            type="button"
            onClick={() => onViewVersion(version)}
            className="flex w-full items-start justify-between rounded p-2 text-left hover:bg-card-hover"
          >
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-text-primary">
                  v{version.versionNumber}
                </span>
                {!version.effectiveTo && (
                  <span className="rounded bg-green-100 px-1.5 py-0.5 text-xs font-medium text-green-700 dark:bg-green-900/30 dark:text-green-400">
                    Current
                  </span>
                )}
              </div>
              {version.changeSummary && (
                <p className="mt-0.5 truncate text-xs text-text-muted">{version.changeSummary}</p>
              )}
            </div>
            <div className="ml-3 flex-shrink-0 text-right">
              <div className="text-xs text-text-muted">{version.author.fullName}</div>
              <div className="text-xs text-text-faint">
                {new Date(version.effectiveFrom).toLocaleDateString()}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
